"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORY_TO_HTTP_STATUS_CODE_RECORD = void 0;
const http_status_codes_1 = require("http-status-codes");
const error_code_category_enum_1 = require("./error_code_category_enum");
/**
 * Readonly Record that contains a mapping of ErrorCodeCategories to their http error codes
 */
exports.CATEGORY_TO_HTTP_STATUS_CODE_RECORD = {
    [error_code_category_enum_1.ErrorTypeCategory.OK]: http_status_codes_1.OK,
    [error_code_category_enum_1.ErrorTypeCategory.CANCELLED]: http_status_codes_1.INTERNAL_SERVER_ERROR,
    [error_code_category_enum_1.ErrorTypeCategory.UNKNOWN]: http_status_codes_1.INTERNAL_SERVER_ERROR,
    [error_code_category_enum_1.ErrorTypeCategory.INVALID_ARGUMENT]: http_status_codes_1.BAD_REQUEST,
    [error_code_category_enum_1.ErrorTypeCategory.DEADLINE_EXCEEDED]: http_status_codes_1.INTERNAL_SERVER_ERROR,
    [error_code_category_enum_1.ErrorTypeCategory.NOT_FOUND]: http_status_codes_1.NOT_FOUND,
    [error_code_category_enum_1.ErrorTypeCategory.CONFLICT]: http_status_codes_1.CONFLICT,
    [error_code_category_enum_1.ErrorTypeCategory.ALREADY_EXISTS]: http_status_codes_1.CONFLICT,
    [error_code_category_enum_1.ErrorTypeCategory.PERMISSION_DENIED]: http_status_codes_1.FORBIDDEN,
    [error_code_category_enum_1.ErrorTypeCategory.UNAUTHENTICATED]: http_status_codes_1.UNAUTHORIZED,
    [error_code_category_enum_1.ErrorTypeCategory.RESOURCE_EXHAUSTED]: http_status_codes_1.TOO_MANY_REQUESTS,
    [error_code_category_enum_1.ErrorTypeCategory.FAILED_PRECONDITION]: http_status_codes_1.BAD_REQUEST,
    [error_code_category_enum_1.ErrorTypeCategory.ABORTED]: http_status_codes_1.INTERNAL_SERVER_ERROR,
    [error_code_category_enum_1.ErrorTypeCategory.OUT_OF_RANGE]: http_status_codes_1.BAD_REQUEST,
    [error_code_category_enum_1.ErrorTypeCategory.UNIMPLEMENTED]: http_status_codes_1.NOT_IMPLEMENTED,
    [error_code_category_enum_1.ErrorTypeCategory.INTERNAL]: http_status_codes_1.INTERNAL_SERVER_ERROR,
    [error_code_category_enum_1.ErrorTypeCategory.UNAVAILABLE]: http_status_codes_1.SERVICE_UNAVAILABLE,
    [error_code_category_enum_1.ErrorTypeCategory.DATA_LOSS]: http_status_codes_1.INTERNAL_SERVER_ERROR,
    [error_code_category_enum_1.ErrorTypeCategory.GATEWAY_TIMEOUT]: http_status_codes_1.GATEWAY_TIMEOUT,
};
//# sourceMappingURL=errors.js.map